// assets/collection-variant-swatches.js
(function () {
  function isCollectionPage() {
    const result =
      document.documentElement.classList.contains('template-collection') ||
      document.body.className.includes('template-collection');

    console.log('[Swatches] isCollectionPage:', result);
    return result;
  }

  function setImg(img, url) {
    if (!img || !url) {
      console.log('[Swatches] setImg skipped', { img: !!img, url });
      return;
    }

    console.log('[Swatches] setImg', img, url);

    img.src = url;
    img.srcset = '';

    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', '');

    const picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.srcset = url;
        source.setAttribute('data-srcset', url);
      });
    }
  }

  function resetHoverSlider(card) {
    const slider = card.querySelector('[data-hover-slider]');
    console.log('[Swatches] resetHoverSlider:', slider);

    if (!slider) return;
    slider.style.transform = 'translate3d(0px, 0px, 0px)';
  }

  function getCardFromSwatch(swatch) {
    const card =
      swatch.closest('.grid-item') ||
      swatch.closest('.product-item') ||
      swatch.closest('.product-card') ||
      swatch.closest('.card-wrapper') ||
      swatch.closest('[data-product-item]') ||
      swatch.closest('[data-product-card]') ||
      swatch.closest('li, .grid__item, .collection__item');

    console.log('[Swatches] matched card:', card);
    return card;
  }

  function updateMainImages(card, primary) {
    const selectors = [
      '[data-product-image-default] img',
      '.product-item__bg img',
      '.product-item__image img',
      '.product-card__image img',
      '.card__media img',
      '.card-media img',
      'img.product-featured-media'
    ];

    selectors.forEach((selector) => {
      const img = card.querySelector(selector);
      console.log('[Swatches] main selector:', selector, img);
      if (img) setImg(img, primary);
    });
  }

  function updateHoverImages(card, primary, secondary) {
    const selectors = [
      'hover-images .product-item__bg__slide img',
      '[data-hover-slider] img',
      '.product-item__bg__slide img',
      '.product-hover-image img'
    ];

    selectors.forEach((selector) => {
      const slides = card.querySelectorAll(selector);
      console.log('[Swatches] hover selector:', selector, 'count:', slides.length);

      if (slides.length) {
        if (slides[0]) setImg(slides[0], primary);
        if (slides[1]) setImg(slides[1], secondary);
      }
    });
  }

  function handleSwatchClick(e) {
    const swatch = e.target.closest('.collection-swatch');
    if (!swatch) return;

    console.log('[Swatches] clicked swatch:', swatch);

    const card = getCardFromSwatch(swatch);
    if (!card) {
      console.log('[Swatches] no card found');
      return;
    }

    const primary = swatch.dataset.variantPrimary;
    const secondary = swatch.dataset.variantSecondary || primary;

    console.log('[Swatches] image data:', { primary, secondary });

    if (!primary) {
      console.log('[Swatches] missing primary image');
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    updateMainImages(card, primary);
    updateHoverImages(card, primary, secondary);
    resetHoverSlider(card);

    card.querySelectorAll('.collection-swatch').forEach((btn) => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    console.log('[Swatches] click handling complete');
  }

  function init() {
    if (!isCollectionPage()) return;

    console.log('[Swatches] init');
    document.removeEventListener('click', handleSwatchClick, true);
    document.addEventListener('click', handleSwatchClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
